import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _results = [];

let ReportResultStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _results;
    },
    getByReport: function(reportId) {
        return _results.filter(function(e) { return e !== undefined && e.reportId == reportId; });
    },
    parseReport: function(report) {
        if (report.length > 0) {
            let reports = [];
            report.forEach(function(r) { if (r !== undefined && !!r.reportId && !reports.includes(r.reportId)) reports.push(r.reportId) });
            reports.forEach(function(r) { ReportResultStore.remove(r); });
            report.forEach(function(r) { if (r !== undefined) _results.push(r); });
        }
    },
    remove: function(reportId) {
        _results = _results.filter(function(e) { return e !== undefined && e.reportId != reportId; });
    },

});

ReportResultStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {
        case ActionTypes.REPORT_RESULTS:
            ReportResultStore.parseReport(action.data);
            ReportResultStore.emitChange();
            break;

        case ActionTypes.REPORT_RESULTS_ERROR:
            ReportResultStore.emitChange();
            break;

        default:
            break;

    }

});

export default ReportResultStore;
